import { ApiError } from './api-client'

export interface CreditErrorPayload {
  code?: string
  message?: string
  actionLabel?: string
  actionHref?: string
  starterCreditHint?: string
  required?: number
  available?: number
}

export interface CreditErrorGuidance {
  title: string
  description: string
  actionLabel: string
  actionHref: string
}

function asPayload(data: unknown): CreditErrorPayload | null {
  return typeof data === 'object' && data !== null ? (data as CreditErrorPayload) : null
}

export function getCreditErrorGuidance(err: unknown): CreditErrorGuidance | null {
  if (!(err instanceof ApiError) || err.status !== 402) return null

  const payload = asPayload(err.data)
  if (payload?.code !== 'CREDITS_EXHAUSTED') return null

  const amountText =
    typeof payload.required === 'number' && typeof payload.available === 'number'
      ? ` Required: ${payload.required}. Available: ${payload.available}.`
      : ''
  const baseDescription =
    payload.message ??
    `This workspace needs more credits before that action can run.${amountText} New OAuth workspaces receive a one-time 200-credit starter grant.`

  return {
    title: 'Credits exhausted',
    description: payload.starterCreditHint
      ? `${baseDescription} ${payload.starterCreditHint}`
      : baseDescription,
    actionLabel: payload.actionLabel ?? 'Open billing',
    actionHref: payload.actionHref ?? '/billing',
  }
}

export function creditErrorMessage(err: unknown): string {
  const guidance = getCreditErrorGuidance(err)
  if (guidance) return `${guidance.description} ${guidance.actionLabel}: ${guidance.actionHref}`
  return err instanceof Error ? err.message : 'Request failed'
}
